
import React from 'react';

const WhatToExpect: React.FC = () => {
  return (
    <div className="mt-12 bg-itmgmt-light-gray p-8 rounded-lg">
      <h2 className="text-xl font-bold text-itmgmt-dark-blue mb-4">What to Expect</h2>
      <div className="space-y-4">
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue rounded-full h-6 w-6 flex items-center justify-center shrink-0 mr-3 mt-0.5">
            <span className="text-white font-bold text-sm">1</span>
          </div>
          <p className="text-gray-600">
            After submitting your request, you'll receive an email confirmation with the details of your appointment.
          </p>
        </div>
        
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue rounded-full h-6 w-6 flex items-center justify-center shrink-0 mr-3 mt-0.5">
            <span className="text-white font-bold text-sm">2</span>
          </div>
          <p className="text-gray-600">
            One of our IT consultants will contact you to confirm the appointment and may ask for additional information to prepare.
          </p>
        </div>
        
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue rounded-full h-6 w-6 flex items-center justify-center shrink-0 mr-3 mt-0.5">
            <span className="text-white font-bold text-sm">3</span>
          </div>
          <p className="text-gray-600">
            During the consultation, we'll discuss your business needs, current IT setup, and potential solutions tailored to your situation.
          </p>
        </div>
        
        <div className="flex items-start">
          <div className="bg-itmgmt-medium-blue rounded-full h-6 w-6 flex items-center justify-center shrink-0 mr-3 mt-0.5">
            <span className="text-white font-bold text-sm">4</span>
          </div>
          <p className="text-gray-600">
            Following the consultation, you'll receive a detailed proposal with recommendations and pricing options.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WhatToExpect;
